import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
} from '@angular/core';
import { AlgoliaChemicalThumbnailComponent } from '@context/frontend/chemical';
import { RelativeTimePipe } from '@context/frontend/common';
import { AlgoliaChemical } from '@context/shared/types/search';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiIcon } from '@taiga-ui/core';

@Component({
	imports: [
		TranslocoModule,
		RelativeTimePipe,
		TuiIcon,
		AlgoliaChemicalThumbnailComponent,
	],
	selector: 'ctx-global-search-chemical',
	templateUrl: 'global-search-chemical.component.html',
	styleUrl: 'global-search-chemical.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalSearchChemicalComponent {
	readonly chemical = input.required<AlgoliaChemical>();

	readonly updatedAt = computed(() => new Date(this.chemical().updatedAt));
}
